var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalApprovalsPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 20H13.3333C13.8014 20.0781 15.1839 19.3587 14.6139 18.8356C14.4642 18.7285 14.256 18.7633 14.1489 18.9127C13.9603 19.1761 13.6554 19.3333 13.3333 19.3333H2.66666C2.11523 19.3333 1.66667 18.8848 1.66667 18.3333V4C1.66667 3.44856 2.11523 3 2.66666 3H13.3333C13.8848 3 14.3333 3.44856 14.3333 4V8.15999C14.3397 8.59905 14.9937 8.59682 15 8.15997C15 8.15999 15 4 15 4C15 3.08105 14.2523 2.33333 13.3333 2.33333H3.06142C3.19946 1.94617 3.56601 1.66667 3.99999 1.66667H14.6667C15.2181 1.66667 15.6667 2.11523 15.6667 2.66667V7.99999C15.6667 8.18408 15.8159 8.33333 16 8.33333C16.1841 8.33333 16.3333 8.18408 16.3333 7.99999V2.66667C16.3333 1.74772 15.5856 1 14.6667 1H4C3.18471 1 2.50708 1.58942 2.36393 2.36393C1.58942 2.50708 1 3.18471 1 4V18.3333C1 19.2523 1.74772 20 2.66666 20Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 5H4C3.44857 5 3 5.44857 3 6V7.33333C3 7.88476 3.44857 8.33333 4 8.33333H5.33333C5.88476 8.33333 6.33333 7.88476 6.33333 7.33333V6C6.33333 5.44857 5.88476 5 5.33333 5ZM5.66666 7.33333C5.66666 7.51725 5.51709 7.66666 5.33333 7.66666H4C3.81624 7.66666 3.66667 7.51725 3.66667 7.33333V6C3.66667 5.81608 3.81624 5.66667 4 5.66667C5.99943 5.70042 5.63246 5.33547 5.66666 7.33333Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 6.33301H7.33341C6.89597 6.34023 6.89477 6.99221 7.33343 6.99967C7.33341 6.99967 10.3334 6.99967 10.3334 6.99967C10.7706 6.99249 10.7722 6.34049 10.3334 6.33301Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 9H4C3.44857 9 3 9.44857 3 10V11.3333C3 11.8848 3.44857 12.3333 4 12.3333H5.33333C5.88476 12.3333 6.33333 11.8848 6.33333 11.3333V10C6.33333 9.44857 5.88476 9 5.33333 9ZM5.66666 11.3333C5.66666 11.5173 5.51709 11.6667 5.33333 11.6667H4C3.81624 11.6667 3.66667 11.5173 3.66667 11.3333V10C3.66667 9.81608 3.81624 9.66667 4 9.66667C5.99943 9.70042 5.63246 9.33547 5.66666 11.3333Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1254 12.0726L15.025 14.553L13.9026 13.4306C13.5944 13.1239 13.1236 13.5923 13.4313 13.902C13.4312 13.902 14.7646 15.2353 14.7646 15.2353C14.8847 15.3557 15.0763 15.3657 15.2084 15.2601L18.5417 12.5934C18.8795 12.3209 18.4684 11.8005 18.1254 12.0726Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.66699C13.243 8.66699 11 10.9098 11 13.667C11.2745 20.3002 20.7265 20.2982 21 13.6669C21 10.9098 18.757 8.66699 16 8.66699ZM16 18.0003C13.6105 18.0003 11.6667 16.0563 11.6667 13.667C11.9047 7.91823 20.0962 7.9199 20.3333 13.667C20.3333 16.0563 18.3895 18.0003 16 18.0003Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 10.333H7.33341C6.89617 10.34 6.89457 10.9923 7.33343 10.9997C7.33341 10.9997 10.3334 10.9997 10.3334 10.9997C10.7707 10.9926 10.7722 10.3404 10.3334 10.333Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 13H4C3.44857 13 3 13.4486 3 14V15.3333C3 15.8848 3.44857 16.3333 4 16.3333H5.33333C5.88476 16.3333 6.33333 15.8848 6.33333 15.3333V14C6.33333 13.4486 5.88476 13 5.33333 13ZM5.66666 15.3333C5.66666 15.5173 5.51709 15.6667 5.33333 15.6667H4C3.81624 15.6667 3.66667 15.5173 3.66667 15.3333V14C3.66667 13.8161 3.81624 13.6667 4 13.6667C5.99943 13.7004 5.63246 13.3355 5.66666 15.3333Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 14.333C6.89617 14.34 6.89457 14.9923 7.33343 14.9997C7.33341 14.9997 10.3334 14.9997 10.3334 14.9997C10.7707 14.9926 10.7722 14.3404 10.3334 14.333H7.33341Z",
    fill: "#5981E9",
    stroke: "#5981E9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalApprovalsPending);
export default __webpack_public_path__ + "static/media/total_approvals_pending.fdf4d1ea44a45352e8abc0421e0b3709.svg";
export { ForwardRef as ReactComponent };